import * as PIXI from "pixi.js-legacy";
import { getSprite } from "../../framework/src/modules/Sprite";
import { EASE, getTweenAsync } from "../../framework/src/modules/Tween";

export default class Multiplier extends PIXI.Sprite {
    centerX: number;
    centerY: number;

    constructor(multi: number) {
        let texture = PIXI.Texture.from("x" + multi);
        super(texture);
        this.centerX = this.width / 2;
        this.centerY = this.height / 2;
        this.position.set(50, -50); //100, 0);
        
        this.pivot.set(this.centerX, 20);
        this.angle = -135;
        this.scale.set(0.1, 0.1);
        this.visible = false;        
    }

    /*
     *  Multiplier Animation  *  
     */
    async animate() {        

        // shared timer for every part of the animation
        let time = 400; // 300;
        // set multiplier visibility;
        this.visible = true;
        // reset / set the promises list;
        let promisesList = [];        

        // move the pivot instead of moving the sprite , for better rotating animation
        promisesList.push(getTweenAsync(this.pivot, { y: this.centerY / 2 }, time, EASE.LINEAR));

        // scale the multplier sprite from 0.1 to 1
        promisesList.push(
            getTweenAsync(
                this.scale,
                { x: 1, y: 1 },
                time, //500,
                //EASE.BACK_O
                EASE.SINE_O
            )
        );

        // rotate and move the position to the center 0,0 of the parent (parent got anchor 0.5)
        promisesList.push(
            await getTweenAsync(
                this,
                { x: 0, y: 0, angle: 25 },//angle: 15 },
                time, //500,
                // EASE.LINEAR
                EASE.SINE_O
            )
        );        

        // execute all promises at once
        await Promise.all(promisesList).then(()=>{ promisesList.length = 0; });    
        
        // animate the movment of the pivot to the center of the sprite, this way the sprite moves but the position stays 
        promisesList.push(
            getTweenAsync(
                this.pivot,
                {
                    x: this.centerX, 
                    y: this.centerY,
                },
                time, //500,
                //EASE.SINE_O
                EASE.QUAD_O
                //EASE.LINEAR //SINE_I
            )
        );

        // make bigger and smaller animation -> animation of scale to half size (0.5), after it scale it to 0.8, after it scale it back to 0.5
        promisesList.push(
            getTweenAsync(
                this.scale,
                { x: 0.5, y: 0.5 },
                time,
                //EASE.LINEAR
                EASE.QUAD_O//BACK_O
            ).then(async () => {
                
                await getTweenAsync(
                    this.scale,
                    //{ x: 0.8, y: 0.8 },
                    {x:1,y:1},
                    time,
                    EASE.CUBI_O//QUAR_O//QUAD_O
                ).then(async () => {
                    let timeForThisSection = time /2;
                    
                    await getTweenAsync(
                        this.scale,
                        { x: 0.5, y: 0.5 },
                        //{x:0.8, y:0.8},
                        //time / 2, //500,
                        timeForThisSection,
                        EASE.LINEAR
                        //EASE.CUBI_O
                        //EASE.QUAD_O
                        //EASE.BACK_O
                    );
                    getTweenAsync(this, {alpha: 0}, timeForThisSection, EASE.LINEAR);             
                });
            })
        );
 
        await Promise.all(promisesList);
        promisesList.length = 0;
    }
}
